import { Deserializable } from "./deserializable.model";

export class Tenant implements Deserializable{
    public tenantName;
    public tenantJobName;
    public databaseName
    public lastRunDateString;
    public last_Run_Outcome;
    public current_Execution_Status;
    public currentExecutionStatus;
    public isLastRunOutcomeFailed;
    public isJobExecuting;
    public current_Execution_Step;
    public lastRunOutcomeStatus;

    deserialize(input: any): this {
        return Object.assign(this, input);
    }
}
